.modal {
  min-width: 600px;
  max-width: 700px;
}

.body {
  margin: 32px 0 0 0;
}

.label {
  font-family: var(--font-semibold);
  font-size: 18px;
  margin-bottom: 8px;
}

.inputsContainer {
  padding-left: 0;
  padding-right: 0;
  margin-left: 40px;
  margin-right: 40px;
}

.row {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  width: 100%;
}

.input {
  flex: 1 1 0;
  width: 100%;
  box-sizing: border-box;
  font-size: 16px;
  padding: 12px 14px;
  border: 2px solid var(--gray-xl);
  border-radius: 8px;
  background: #fff;
  outline: none;
  transition: border-color 0.2s;
}

.analysisIdInput {
  margin-bottom: 32px;
}

.input:focus {
  border-color: var(--blue-l);
}

.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 32px;
}

.modalButton {
  width: 240px;
  height: 40px;
  border-radius: 14px;
  font-size: 20px;
  font-family: var(--font-bold);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s, border-color 0.2s, color 0.2s;
  cursor: pointer;
  outline: none;
  margin: 0 8px;
  box-sizing: border-box;
}

.cancel {
  min-width: 120px;
}

.continue {
  min-width: 120px;
}
